import EmptyData from "core/components/EmptyData";
import PageHeader from "core/components/Header/PageHeader";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { useScrollToTop } from "core/hooks/useScrollToTop";
import { _t } from "core/language";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import { RouterName } from "core/router";
import { useRecipe } from "modules/Ingredients/hooks/recipe";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useLocation, useSearchParams } from "react-router-dom";
import ItemCommunity from "../components/ItemCommunity";
import SelectCategoryCommunity from "../components/SelectCategoryCommunity ";
import SkeletonListCommunity from "../components/SkeletonListCommunity";
import { useGetCommunityList } from "../hooks/list";

export interface CommunityTabProps {
  tab: "trending" | "follow" | "video";
}
const CommunityListPage = () => {
  useScrollToTop()
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useCustomNavigate();
  const location = useLocation();
  const from = location.state?.from;
  console.log("from", from);
  const tab = searchParams.get("tab") || "trending";
  const [filter, setFilter] = useState<CommunityTabProps>({
    tab: tab as "trending" | "follow" | "video",
  });
  const { loading, data, loadMore, lastPage, params } =
    useGetCommunityList(filter);

  const { resetRecipes } = useRecipe();
  const [emptyData, setEmptyData] = useState(false);

  useEffect(() => {
    if (!data?.length && !loading && params?.page === 1) {
      setEmptyData(true);
    } else {
      setEmptyData(false);
    }
  }, [data]);

  const handleFetchMore = () => {
    console.log("handleFetchMore", filter.tab, data.length, params.limit);
    if (filter.tab === "trending") {
      if (params?.last_id) {
        console.log("loadMore");
        loadMore();
      }
    } else {
      if (lastPage > params?.page) {
        loadMore();
      }
    }
  };

  const handleSelect = (key: string) => {
    console.log("handleSelect", key);
    searchParams.set("tab", key);
    setSearchParams({ tab: key }, { replace: true });
    navigate(RouterName.COMMUNITY_LIST + "?" + searchParams.toString(), {
      replace: true,
    });
    setFilter({ tab: key as any });
  };
  // const handleSelect = (key: string) => {
  //   searchParams.set("tab", key);
  //   setSearchParams({ tab: key });
  //   navigate(RouterName.COMMUNITY_LIST + "?" + searchParams.toString());
  //   setFilter({ tab: key as any });
  // };

  return (
    <AppLayout className={` relative no-scrollbar bg-[#EEEEEE]`}>
      <PageHeader
        className="fixed w-full z-[200] bg-white"
        title={_t("comunity.title")}
        showCart={false}
        handleGoBack={() => { 
          sessionStorage.removeItem("scroll-community");
          navigate(RouterName.MAIN);
        }}
      />
      <SelectCategoryCommunity
        onSelect={handleSelect}
        active={searchParams.get("tab") || "trending"}
      />
      <div className="pt-[130px]">
        <InfiniteScroll
          dataLength={data?.length || 0}
          next={handleFetchMore}
          hasMore={!!data?.length}
          loader={null}
          className=""
        >
          {(data?.length ? data : [])?.map((item: any, key: number) => (
            <ItemCommunity community={item} key={key} />
          ))}
        </InfiniteScroll>
        {filter.tab === "trending"
          ? params?.last_id && loading && <SkeletonListCommunity />
          : params?.page > 1 && loading && <SkeletonListCommunity />}

        {!data?.length && loading ? (
          <div className="">
            {Array.from(Array(params?.page === 1 ? 3 : 1).keys()).map(
              (e: number) => (
                <SkeletonListCommunity key={e} />
              )
            )}
          </div>
        ) : !data?.length && !loading && emptyData ? (
          <div className="mt-2 bg-white p-4 h-[80vh]">
            <EmptyData message={_t("main.community.no_data")} />
          </div>
        ) : null}
        {
          !data?.length && !loading && params?.last_id === null && filter.tab === 'trending' ? (
            <div className="mt-2 bg-white p-4 h-[80vh]">
              <EmptyData message={_t("main.community.no_data")} />
            </div>
            ) : ''
        }
      </div>
      <BottomNavigation onNavigateChange={resetRecipes} activeIndex={4} />
    </AppLayout>
  );
};

export default CommunityListPage;
